import './Game.css';
import HeadUpDisplay from './HeadUpDisplay';
import SelectAdvancement from './SelectAdvancement';
import NewAdvancements from './NewAdvancements';
import NewUniqueResource from './NewUniqueResource';
import Hint from './Hint';
import LogBook from './LogBook';
import SplashScreen from './SplashScreen';

function Game({ dialogState, gameState, openLogBook, onSelectAdvancement, onRemoveAdvancements, onCloseNewAdvancements, onCloseHint, onCloseNewUniqueResource, onCloseLogBook, onCloseSplashScreen, buyHint }) {
  return (
    <>
      <HeadUpDisplay state={gameState} openLogBook={openLogBook} buyHint={buyHint}></HeadUpDisplay>
      { dialogState.advancementOptions &&
        <SelectAdvancement
        onSelectAdvancement={onSelectAdvancement}
        onRemoveAdvancements={onRemoveAdvancements}
        options={dialogState.advancementOptions}
        removeCost={dialogState.advancementRemoveCost}
        currentAP={gameState.advancementPoints}
        uv={dialogState.advancementUV} /> }
      { dialogState.newAdvancementsNews &&
        <NewAdvancements onClose={onCloseNewAdvancements} news={dialogState.newAdvancementsNews} /> }
      { dialogState.hint &&
        <Hint onClose={onCloseHint} hint={dialogState.hint} /> }
      { dialogState.newUniqueResource &&
        <NewUniqueResource onClose={onCloseNewUniqueResource} resource={dialogState.newUniqueResource} /> }
      { dialogState.logBook &&
        <LogBook onClose={onCloseLogBook} log={dialogState.logBook} /> }
      { dialogState.splashScreen &&
        <SplashScreen onClose={onCloseSplashScreen} /> }  
    </>
  );
}

export default Game;
